import { render } from "./MediaCenter.vue?vue&type=template&id=3ccb0fd0"
import script from "./MediaCenter.vue?vue&type=script&lang=js"
export * from "./MediaCenter.vue?vue&type=script&lang=js"

import "./MediaCenter.vue?vue&type=style&index=0&id=3ccb0fd0&lang=scss"

import exportComponent from "/home/kreativ-mobil.com/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__